<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <material-card icon="mdi-clipboard-text" inline title="Skills"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Skills</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="9">
            <v-card-text class="pt-0 pr-1"
              :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
              <v-text-field
                :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                v-model="search" hide-details="true" append-icon="mdi-magnify" class="ml-auto mb-2"
                label="Search" dense single-line style="max-width: 350px" />
              <v-btn small v-if="isWrite" elevation="1" v-on:click="modalOpen()"
                :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
                <v-icon left>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-card-text>
          </v-col>

          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete @change="getSkills()" placeholder="Please select Academic Year"
                label="Academic Year" name="aySelect" v-model="academicYear1" required
                item-value="id" :items="academicYears" key="id" item-text="academicYear">
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-row>
        <v-data-table :search.sync="search" :footer-props="{
            'items-per-page-options': [10, 20, 40,100]
          }" :items-per-page="20" :headers="headers" :items="classData">
          <template v-slot:item.className="{ item }">
            <span v-for="(classObject, i) in item.gradeSkillsClassSectionMaps" :key="i">
              <v-chip class="ma-1" draggable>
                {{ classObject.studentClass.name }}
              </v-chip>

            </span>
            <!-- <div v-for="(classObject, i) in item.gradeSkillsClassSectionMaps" :key="i">
              <div>
                <p>
                  {{ classObject.studentClass.name }}
                </p>
              </div>
            </div> -->
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:item.subSkills="{ item }">
            <router-link
              :to="{ name: 'listSubSkills', params: { skillId: item.id, skillName: item.name } }">
              <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" small> View Sub Skills </v-btn>
            </router-link>
          </template>
          <template v-slot:item.actions="{ item }" v-if="isWrite">
            <v-btn color="success" class="px-2 ml-1 ma-1" @click="getSingleSkill(item.id)"
              min-width="0" small>
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog persistent v-model="modalOk" max-width="900" :active="modalOk" :on-cancel="
          () => {
            modalOk = false
            clearData()
          }
        ">
        <form @submit.prevent="addSkill">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Add Skills</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="
                    () => {
                      ;(modalOk = false), clearData()
                    }
                  ">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete placeholder="Select academic year" label="Academic Year"
                    name="aySelect" v-model="selectedayID" required item-value="id"
                    :items="academicYears" key="id" item-text="academicYear"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <label class="label"> Classes </label>
                  <div>
                    <multiselect
                      placeholder="Select classes" label="name" track-by="name" item-value="id"
                      class="overflowmultiselect1" :close-on-select="false" :clear-on-select="false"
                      :preserve-search="false" :multiple="true" :options="classes"
                      v-model="selectedClassID">
                      <template slot="selection" slot-scope="{ values, isOpen }"><span
                          class="multiselect__single"
                          v-if="values.name &amp;&amp; !isOpen">{{ values.name }} </span></template>
                    </multiselect>
                  </div>
                  <!-- <v-autocomplete placeholder="--Select--" multiple class="overflowmultiselect1"
                    label="Class" name="classSelect" v-model="selectedClassID" item-value="id"
                    :items="classes" key="id" item-text="name">
                  </v-autocomplete> -->
                </v-col>
                <!-- <v-col cols="12" md="6">
                  <v-autocomplete placeholder="--Select--" multiple label="Section"
                    name="sectionSelect" v-model="selectedSectionID" item-value="id"
                    :items="classSection" key="id" item-text="name">
                  </v-autocomplete>
                </v-col> -->
                <v-col cols="12" md="6">
                  <v-text-field label="Name" v-model.trim="skillName" placeholder="Skill" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea rows="2" label="Description" clearable clear-icon="mdi-close-circle"
                    v-model.trim="desc" placeholder="write" maxlength="200" counter="200">
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Remark" v-model.trim="remark" placeholder="remark"
                    maxlength="200"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field type="number" min="1" label="Position" v-model.trim="position"
                    placeholder="position">
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">{{ editMode ? 'Save' : 'Add' }}</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import Multiselect from 'vue-multiselect'
export default {
  name: 'classList',
  components: {
    // MaterialCard
    Multiselect
  },
  data () {
    return {
      classData: [],
      academicYears: [],
      search: '',
      isLoading: false,
      total: '',
      modalOk: false,
      classes: [],
      selectedClassID: [],
      classSection: [],
      selectedSectionID: [],
      selectedayID: '',
      academicYear1: null,
      globalAy: null,
      academicYearID: '',
      skillName: '',
      desc: '',
      remark: '',
      position: null,
      editMode: false,
      selectedId: '',
      isWrite: false,
      headers: [
        { text: 'Skills', value: 'name', sortable: false },
        { text: 'Class Name', value: 'className', sortable: false },
        // { text: 'Section', value: 'section', sortable: false },
        { text: 'Description', value: 'description', sortable: true },
        { text: 'Remarks', value: 'remark', sortable: false },
        { text: 'Sub skills', value: 'subSkills', align: 'center', sortable: false },
        { text: 'Action', value: 'actions', sortable: false }
      ]
    }
  },
  created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    console.log('isWrite', this.isWrite, 'this.$route', this.$route)
    // this.getSkills()
    this.getClassList()
    this.getAcademicYears()
    this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.academicYear1 = this.academicYear.id
          this.getSkills()
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },

    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    modalOpen () {
      this.modalOk = true
    },
    addSkill: async function () {
      if (this.selectedClassID.length === 0) {
        this.errMsg('Kindly select Class!')
        return false
      } else if (this.skillName === '') {
        this.errMsg('Name Input cannot be empty!')
        return false
      } else if (this.selectedayID === '') {
        this.errMsg('Kindly select Academic Year!')
        return false
      }
      let classSelection = [...new Set(this.selectedClassID.map((obj) => obj.id))]
      let formData = {
        classID: classSelection,
        // sectionID: this.selectedSectionID,
        academicYearID: this.selectedayID,
        name: this.skillName,
        isActive: true,
        description: this.desc,
        remark: this.remark,
        position: this.position
      }
      let url = this.editMode ? `${constants.API_URL}/api/grade-module/skill/${this.selectedId}` : `${constants.API_URL}/api/grade-module/skill`
      // Removed v1 for the add skill calling wrong api
      try {
        let { data } = await http.post(url, formData)
        this.getSkills()
        this.okMsg(data.toString())
        this.modalOk = false
        this.clearData()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getSkills: async function () {
      try {
        this.isLoading = true
        let formData = {
          academicYearID: this.academicYear1
        }
        const { data } = await http.post(`${constants.API_URL}/api/v1/grade-module/skill`, formData)
        // const { data } = await http.get(`${constants.API_URL}/api/grade-module/skill?academicYearID=${this.academicYear1}`)
        this.total = data.length
        this.classData = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getSingleSkill: async function (id) {
      this.editMode = true
      this.selectedId = id
      try {
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/skill/${id}`)
        this.modalOk = true
        this.skillName = data.name
        this.desc = data.description
        this.remark = data.remark ? data.remark : null
        let gradeSkillClassMap = data.gradeSkillsClassSectionMaps
        this.selectedClassID = [...new Set(gradeSkillClassMap.map((obj) => obj.studentClass))]
        // await this.changeSections()
        // this.selectedSectionID = [...new Set(gradeSkillClassMap.map((obj) => obj.sectionID))]
        this.selectedayID = data.academicYearID
        this.position = data.position ? data.position : null
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getClassList: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=true`)
        if (data) {
          this.classes = data.map((obj) => {
            return {
              id: obj.id,
              name: obj.name,
              section: obj.studentSections
            }
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      console.log('trigger')
      this.classSection = []
      try {
        if (this.selectedClassID.length > 0) {
          //   await this.getStudents(this.franchiseeID)
          // }

          this.isLoading = true
          for (let index = 0; index < this.selectedClassID.length; index++) {
            var sectionId = this.selectedClassID[index]
            var section = this.classes.find((obj) => obj.id === sectionId)
            console.log(section)
            if (section) {
              // var arr = section.section
              var arr = []
              var className = ''
              arr = section.section.map((obj) => {
                className = section.name
                return {
                  id: obj.id,
                  name: className + ' - ' + obj.name
                }
              })
              // this.classSection = section.section
              this.classSection.push.apply(this.classSection, arr)
              // this.classSection.concat(section.section)
            } else {
              this.classSection = []
            }
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    clearData () {
      this.skillName = ''
      this.remark = ''
      this.desc = ''
      this.selectedClassID = []
      this.selectedSectionID = []
      this.editMode = false
      this.position = null
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
